import { createAction, createReducer } from 'redux-act';
import { delay } from 'shared/utils/utilHelper';

const initialState = {
  fetchLoading1: false,
  fetchLoading2: false,
  data1: [],
  data2: [],
  error1: false,
  error2: false,
  message1: '',
  message2: ''
};

const fetchOceanRateAndFuelTable1 = createAction(
  'fetch ocean rate and fuel table 1'
);
const fetchOceanRateAndFuelTable1Success = createAction(
  'fetch ocean rate and fuel table 1 success'
);
const fetchOceanRateAndFuelTable1Error = createAction(
  'fetch ocean rate and fuel table 1 error'
);

const fetchOceanRateAndFuelTable2 = createAction(
  'fetch ocean rate and fuel table 2'
);
const fetchOceanRateAndFuelTable2Success = createAction(
  'fetch ocean rate and fuel table 2 success'
);
const fetchOceanRateAndFuelTable2Error = createAction(
  'fetch ocean rate and fuel table 2 error'
);

export default createReducer(
  {
    [fetchOceanRateAndFuelTable1]: (state) => ({
      ...state,
      fetchLoading1: true,
      error1: false
    }),
    [fetchOceanRateAndFuelTable1Success]: (state, payload) => ({
      ...state,
      data1: payload,
      fetchLoading1: false,
      error1: false
    }),
    [fetchOceanRateAndFuelTable1Error]: (state, payload) => ({
      ...state,
      message1: payload,
      error1: true,
      data1: [],
      fetchLoading1: false
    }),
    [fetchOceanRateAndFuelTable2]: (state) => ({
      ...state,
      fetchLoading2: true,
      error2: false
    }),
    [fetchOceanRateAndFuelTable2Success]: (state, payload) => ({
      ...state,
      data2: payload,
      fetchLoading2: false,
      error2: false
    }),
    [fetchOceanRateAndFuelTable2Error]: (state, payload) => ({
      ...state,
      message2: payload,
      error2: true,
      data2: [],
      fetchLoading2: false
    })
  },
  initialState
);

export const fetchOceanRateAndFuelTable1Action = () => {
  return async (dispatch) => {
    try {
      dispatch(fetchOceanRateAndFuelTable1());
      await delay(1000);
      dispatch(fetchOceanRateAndFuelTable1Success());
    } catch (error) {
      dispatch(fetchOceanRateAndFuelTable1Error());
    }
  };
};

export const fetchOceanRateAndFuelTable2Action = () => {
  return async (dispatch) => {
    try {
      dispatch(fetchOceanRateAndFuelTable2());
      await delay(1000);
      dispatch(fetchOceanRateAndFuelTable2Success());
    } catch (error) {
      dispatch(fetchOceanRateAndFuelTable2Error());
    }
  };
};
